// DL3.10 Login
export function dataLayerLogin() {
    dataLayer.push({
        event: "action.login.sazkaklub",
    });
}

// DL3.20 First login
export function dataLayerFirstLogin() {
    dataLayer.push({
        event: "action.firstLogin.sazkaklub",
    });
}

// DL3.30 Registration finished
export function dataLayerRegistrationSuccess(kind: "offline" | "online") {
    dataLayer.push({
        event: "action.registration.sazkaklub",
        action: {
            registration: {
                kind: kind,
            },
        },
    });
}

// DL3.40 Registration error
export function dataLayerRegistrationError(fieldName: string, message: string) {
    dataLayer.push({
        event: "action.registrationError.sazkaklub",
        action: {
            registrationError: {
                field: fieldName,
                message: message,
            },
        },
    });
}

// DL3.50 Wheel spin success
export function dataLayerWheelSpinSuccess(spinId: string) {
    dataLayer.push({
        event: "action.spin.sazkaklub",
        action: {
            spin: {
                id: spinId,
            },
        },
    });
}

// DL3.60 Wheel spin error
export function dataLayerWheelSpinError(errorMessage: "Spin expired" | "Spin used" | "Process error") {
    dataLayer.push({
        event: "action.spinError.sazkaklub",
        action: {
            spinError: {
                error: errorMessage,
            },
        },
    });
}

// DL 3.70 App download
export function dataLayerAppDownload(platform: "ios" | "android") {
    dataLayer.push({
        event: "action.download.app",
        action: {
            download: {
                platform: platform,
                name: "sazka",
            },
        },
    });
}

// DL 3.80 Add favorite bet
export function dataLayerAddFavoriteBet(label: string) {
    dataLayer.push({
        event: "action.addbet.sazkaklub",
        action: {
            addbet: {
                label: label,
            },
        },
    });
}

// DL 3.81 Edit favorite bet
export function dataLayerEditFavoriteBet(label: string) {
    dataLayer.push({
        event: "action.editbet.sazkaklub",
        action: {
            editbet: {
                label: label,
            },
        },
    });
}

// DL 3.82 Remove favorite bet
export function dataLayerRemoveFavoriteBet(label: string) {
    dataLayer.push({
        event: "action.deletebet.sazkaklub",
        action: {
            deletebet: {
                label: label,
            },
        },
    });
}

// DL 3.90 Submit personal data
export function dataLayerSubmitPersonalData() {
    dataLayer.push({
        event: "action.submitPersonalData.sazkaklub",
    });
}
